import { splitInstanceBasePath } from "@/lib/dashboard-routes";
import { instanceBasePath, urlInstanceSlug } from "@/lib/named-org";
import { useMemo } from "react";
import {
  useParams,
  usePathname,
  useSearchParams,
  type ReadonlyURLSearchParams,
} from "next/navigation";

/** The current pathname relative to the instance base path (`/acme/runs`, never `/enterprise/ghe/acme/runs`). */
export function useDashboardPathname(): string {
  return splitInstanceBasePath(usePathname() ?? "").pathname;
}

export function useDashboardSearchParams(): ReadonlyURLSearchParams {
  const searchParams = useSearchParams();
  return useMemo(
    () => searchParams ?? new URLSearchParams(),
    [searchParams],
  ) as ReadonlyURLSearchParams;
}

export function useDashboardParams<
  T extends Record<string, string | string[]> = Record<
    string,
    string | string[]
  >,
>(): T {
  return (useParams<T>() ?? {}) as T;
}

export function useDashboardInstanceSlug(
  defaultInstanceSlug?: string | null,
): string {
  const pathname = usePathname();
  return urlInstanceSlug(pathname ?? undefined, defaultInstanceSlug);
}

/** `""` on github.com, `/enterprise/{slug}` on the enterprise instance the URL addresses. */
export function useInstanceBasePath(): string {
  return instanceBasePath(useDashboardInstanceSlug());
}
